import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { EFSolarPanel } from '@/components/UI/svg/mm100';
import EFVideo from '@/components/UI/EFVideo';

export default function home2() {
    const { useLang, useEffect, useRouter, useState, useRef } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const [enter, setEnter] = useState(false);
    const videoRef = useRef();
    useEffect(() => {
        // mm100_home2进入视窗渲染video
        const videoEl = document.querySelector('.kitProduct-h5 .home2') as HTMLElement;
        const scene = new ScrollMagic.Scene({
            triggerElement: videoEl,
            triggerHook: 1,
            offset: 0,
        });
        scene.on('enter', () => {
            setEnter(true);
        });
        scene.addTo(controller);
    }, []);

    useEffect(() => {
        if (videoRef) {
            const videoBoxEl = document.querySelector('.home2 .videoBox') as HTMLElement;
            // 视频的一半区域进入视窗后开始播放
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.kitProduct-h5 .home2 .videoBox',
                triggerHook: 1,
                offset: videoBoxEl?.offsetHeight / 2,
            });
            scene1.on('enter', () => {
                videoRef?.current?.play();
            });
            controller.addScene(scene1);
        }
    }, [videoRef]);

    return (
        <div className={`home2 ${css.home2}`}>
            <div className="textBox">
                <p className="guide">{t('presale.product.home2_guide')}</p>
                <p className="title">{t('presale.product.home2_title')}</p>
                <p className="text">{t('presale.product.home2_text')}</p>
                <div className="iconText">
                    <div className="iconBox">
                        <EFSolarPanel width=".42rem" height=".43rem" />
                    </div>
                    <div className="iconRight">
                        <p className="iconTitle">{t('presale.product.home2_sub_title')}</p>
                        <p className="iconDesc">{t('presale.product.home2_sub_desc')}</p>
                    </div>
                </div>
            </div>
            <div className="videoBox">
                {enter && (
                    <EFVideo
                        ref={videoRef}
                        className="mm100_home2_video_h5"
                        sources={['/video/mm100/backup_h5.mp4']}
                        width={'100%'}
                        height={'100%'}
                        playsInline
                        autoPlay={false}
                        loop
                        preload="auto"
                        muted
                    />
                )}
            </div>
        </div>
    );
}
